import React from 'react'
import { ChartCard } from '.'
import { DonutChartLegend as Legend, PieChart, GenderChart } from '../../../components'

const data = [
  {
    name: 'Direct',
    label: 'Direct',
    value: 312
  },
  {
    name: 'Indirect',
    label: 'Indirect',
    value: 132
  }
]

const dataGender = [
  {
    name: 'Male',
    label: 'Male',
    value: 3312
  },
  {
    name: 'Female',
    label: 'Female',
    value: 1432
  }
]

const total = 444
// const colors = ['#2BB36F', '#345665']
const colorsGender = ['#52BAE2', '#FF5448']

const BeneficiariesSection = () => {
  return (
    <div>
      <h2 className="text-lg lg:text-2xl mb-8 lg:mb-12 uppercase font-bold">Beneficiaries</h2>
      <div className="flex flex-wrap -mx-4">
        <div className="w-full lg:w-1/2 px-4 mb-8 lg:mb-16">
          <h4 className="lg:text-lg font-bold uppercase mb-1 text-gray-444">Total</h4>
          <p className="text-5xl lg:text-6xl">5,213</p>
        </div>
        <div className="hidden lg:block w-full lg:w-1/2 px-4 mb-10 lg:mb-16">
          {/* <ChartCard
            title="Beneficiaries By Type"
            legend={<Legend data={data} total={total} colors={colors} />}
            chart={<PieChart data={data} total={total} colors={colors} />}
          /> */}
        </div>
        <div className="w-full lg:w-1/2 px-4 mb-10 lg:mb-0">
          <h4 className="lg:text-lg font-bold uppercase mb-5 text-gray-444">Beneficiaries By Gender</h4>
          <div className="mb-5">
            <GenderChart male={dataGender[0].value} female={dataGender[1].value}/>
          </div>
          <Legend data={dataGender} colors={['#52BAE2', '#FF5448']} total={dataGender[0].value + dataGender[1].value} />
        </div>
        <div className="w-full lg:w-1/2 px-4 mb-2 lg:mb-0">
          <ChartCard
            title="Beneficiaries By Gender Difable"
            legend={<Legend data={data} total={total} colors={colorsGender} />}
            chart={<PieChart data={data} total={total} colors={colorsGender} />}
          />
        </div>
      </div>
    </div>
  )
}

export { BeneficiariesSection }